import { useState, useEffect, useRef } from 'react'
import {
    Layout,
    Row,
    Col,
    Divider,
    Image,
    message
} from 'antd';
import { API } from "aws-amplify";
import { Link, useNavigate, useLocation } from 'react-router-dom'
import { Hub, Auth } from 'aws-amplify'
import { v4 as uuidv4 } from 'uuid'
import { UserContext } from '../../GestorContext'

import HeaderMenu from './HeaderMenu'
import UserCard from './UserCard/UserCard'
import '../../styles/AppFrame.css'
import ResponsiveVisibility from '../common/ResponsiveVisibility';
//import { createLogger } from 'fork-ts-checker-webpack-plugin/lib/logger/LoggerFactory';


const { Header, Content } = Layout;

const AppFrame = ({ children }) => {

    const [user, setUser] = useState()
    const navigate = useNavigate()
    const { pathname } = useLocation()
    const timeoutRef = useRef(null);

    const resetTimeout = () => {
        if (timeoutRef.current) {
            clearTimeout(timeoutRef.current);
        }
        timeoutRef.current = setTimeout(() => {
            handleLogout();
        }, 15 * 60 * 1000); 
    };

    const handleLogout = async () => {
        await Auth.signOut();
        setUser(null);
        navigate('/login');
        message.warning('Sesión cerrada por inactividad.');
    };

    const createLog = async (values) => {
        const usuario = await API.graphql({
            query: `mutation CreateMetrics( $input: CreateMetricsInput!){
                    createMetrics(input:$input) {
                        id
                    }
                }`,
            variables: {
                input: values
            },
        });
    };

    const getUserInfo = () => {
        Auth.currentAuthenticatedUser()
            .then(data => setUser(data))
            .catch(err => {
                //console.log("Error con sesion de usuario", err)
                navigate('/login')
            })
    }

    useEffect(() => {
        const events = ['click', 'mousemove', 'keydown', 'scroll'];
        const resetTimer = () => resetTimeout();

        events.forEach(event => window.addEventListener(event, resetTimer));

        resetTimeout();

        return () => {
            events.forEach(event => window.removeEventListener(event, resetTimer));
            if (timeoutRef.current) {
                clearTimeout(timeoutRef.current);
            }
        };
    }, []);


    useEffect(() => {
        if (pathname.split('/')[1] !== 'login' && pathname !== '/' && user) {
            const { signInUserSession } = user
            const { idToken } = signInUserSession
            const { payload } = idToken
            if (payload['cognito:groups'].includes('Business')) {
                if (pathname !== '/BusinessCLM') {
                    navigate('/BusinessCLM')
                }
                return
            }
            switch (pathname.split('/')[1]) {
                case 'export':
                    if (!payload['cognito:groups'].includes('Admin') && !payload['cognito:groups'].includes('Company')) navigate('/audience')
                    break;
                case 'exports':
                    if (!payload['cognito:groups'].includes('Admin') && !payload['cognito:groups'].includes('Company')) navigate('/audience')
                    break;
                case 'users':
                    if (!payload['cognito:groups'].includes('Admin')) navigate('/audience')
                    break;
                case 'user':
                    if (!payload['cognito:groups'].includes('Admin')) navigate('/audience')
                    break;
                default:
                    break;
            }
        }
    }, [pathname, user])

    useEffect(() => {
        const validate = async () => {
          Hub.listen('auth', (data) => {
            const { payload } = data;
            switch (payload.event) {
              case 'signIn':
                const user = payload.data;
                setUser(user);
                localStorage.setItem('authUser', JSON.stringify(user));
                createLog({
                  action: "Inicio de sesión",
                  id: uuidv4(),
                  user: payload.data.username,
                  view: "Login",
                });
                navigate('/');
                break;
              case 'signOut':
                setUser(null);
                localStorage.removeItem('authUser');
                createLog({
                  action: "Sesión cerrada",
                  id: uuidv4(),
                  user: payload.data.username,
                  view: "Logout",
                });
                navigate('/login');
                break;
              default:
                setUser(null);
                navigate('/login');
                break;
            }
          });
          const storedUser = localStorage.getItem('authUser');
          if (storedUser) {
            setUser(JSON.parse(storedUser));
          } else {
            getUserInfo();
          }
        };
        validate();
      }, []);

    return (
        <UserContext.Provider value={user}>
            <Layout className="HeaderGA">
                {user && <Header
                    style={{
                        backgroundColor: 'var(--background1)',
                        position: 'fixed',
                        zIndex: 1000,
                        width: '100%'
                    }}
                >
                    <Row align='middle' justify="center">
                        <Col span={3} className="LogoGA" style={{ marginLeft: -10}}>
                            <Link to='/audience'>
                                <Image
                                    src="/images/header/Telcel_web.png"
                                    preview={false}
                                />
                            </Link>
                        </Col>
                        <ResponsiveVisibility maxWidth={1108}>
                            <Col span={1} style={{marginLeft: "-40px"}}>
                                <Divider className="DividerHeaderGA" type="vertical" />
                            </Col>
                            <Col span={5} className="TituloBoldGA" style={{ userSelect: 'none' }}>
                                GESTOR DE AUDIENCIAS
                            </Col>
                        </ResponsiveVisibility>
                        <Col span={12}>
                            <Row>
                                <Col span={1}>
                                </Col>
                                <Col span={22}>
                                    <HeaderMenu pathname={pathname} />
                                </Col>
                                <Col span={1}>
                                </Col>
                            </Row>
                        </Col>
                        <Col span={3}>
                            <UserCard />
                        </Col>
                    </Row>
                </Header>}
                <Content className="site-layout styleContent">
                    <div className="site-layout-background styleContainer">
                        {children}
                    </div>
                </Content>
            </Layout>
        </UserContext.Provider>
    )
}

export default AppFrame
